
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/events-list",
      function () {
        return require("private-next-pages/events-list.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/events-list"])
      });
    }
  